export {PlansScreen as default} from "@features/swing-trading/screens";
